import { all, fork } from 'redux-saga/effects';

import usersSaga from './users/saga';
import settingsSaga from './settings/saga';

const rootSaga = function* root(): any {
  yield all([fork(settingsSaga)]);
  yield all([fork(usersSaga)]);
};

export default rootSaga;
